import { reducers } from '@saucelabs/sl-module-root-cause';

import { NAMESPACE } from './types';

export default reducers.createRootCauseReducer(NAMESPACE);
